import(/* webpackMode: "eager" */ "/vercel/path0/apps/landing/src/app/global-error.tsx");
